 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","view-application-Payroll-final-payroll-approval-detail-final-payroll-approval-detail-module":"view-application-Payroll-final-payroll-approval-detail-final-payroll-approval-detail-module","view-application-Payroll-final-payroll-approval-final-payroll-approval-module":"view-application-Payroll-final-payroll-approval-final-payroll-approval-module","view-application-Payroll-payslip-generation-payslip-generation-module":"view-application-Payroll-payslip-generation-payslip-generation-module","view-application-Payroll-trail-final-payroll-generation-detail-trail-final-payroll-generation-detail-module":"view-application-Payroll-trail-final-payroll-generation-detail-trail-final-payroll-generation-detail-module","view-application-Payroll-trail-final-payroll-generation-trail-final-payroll-generation-module":"view-application-Payroll-trail-final-payroll-generation-trail-final-payroll-generation-module","view-application-Payroll-view-payslip-team-view-payslip-team-module":"view-application-Payroll-view-payslip-team-view-payslip-team-module","view-application-employee-report-report-module":"view-application-employee-report-report-module","default~view-dashboard-employee-dashboard-employee-dashboard-module~view-dashboard-management-dashbo~88dd1d3f":"default~view-dashboard-employee-dashboard-employee-dashboard-module~view-dashboard-management-dashbo~88dd1d3f","view-dashboard-employee-dashboard-employee-dashboard-module":"view-dashboard-employee-dashboard-employee-dashboard-module","view-dashboard-management-dashboard-management-dashboard-module":"view-dashboard-management-dashboard-management-dashboard-module","view-dashboard-report-benefit-and-deduction-report-benefit-and-deduction-report-module":"view-dashboard-report-benefit-and-deduction-report-benefit-and-deduction-report-module","view-admin-audit-log-audit-log-module":"view-admin-audit-log-audit-log-module","view-admin-company-approval-search-company-approval-search-module":"view-admin-company-approval-search-company-approval-search-module","view-admin-configuration-detail-config-detail-component-module":"view-admin-configuration-detail-config-detail-component-module","view-admin-configuration-search-configuration-search-module":"view-admin-configuration-search-configuration-search-module","view-admin-email-tracking-email-tracking-module":"view-admin-email-tracking-email-tracking-module","view-admin-group-detail-group-detail-module":"view-admin-group-detail-group-detail-module","view-admin-group-search-group-search-module":"view-admin-group-search-group-search-module","view-admin-process-log-process-log-module":"view-admin-process-log-process-log-module","view-admin-resource-resource-module":"view-admin-resource-resource-module","view-admin-role-detail-role-detail-module":"view-admin-role-detail-role-detail-module","view-admin-role-search-role-search-module":"view-admin-role-search-role-search-module","view-admin-user-detail-user-detail-module":"view-admin-user-detail-user-detail-module","view-admin-user-search-user-search-module":"view-admin-user-search-user-search-module","view-application-attendance-attendance-adjust-request-approval-attendance-adjust-request-approval-module":"view-application-attendance-attendance-adjust-request-approval-attendance-adjust-request-approval-module","view-application-attendance-attendance-adjust-request-approval-detail-attendance-adjust-request-approval-detail-module":"view-application-attendance-attendance-adjust-request-approval-detail-attendance-adjust-request-approval-detail-module","view-application-attendance-attendance-policy-attendance-policy-module":"view-application-attendance-attendance-policy-attendance-policy-module","view-application-attendance-attendance-request-approval-attendance-request-approval-module":"view-application-attendance-attendance-request-approval-attendance-request-approval-module","view-application-attendance-attendance-request-approval-detail-attendance-request-approval-detail-module":"view-application-attendance-attendance-request-approval-detail-attendance-request-approval-detail-module","view-application-attendance-attn-adjt-req-emp-team-list-attn-adjt-req-emp-team-list-module":"view-application-attendance-attn-adjt-req-emp-team-list-attn-adjt-req-emp-team-list-module","view-application-attendance-flex-time-excess-duty-approval-flex-time-excess-duty-approval-module":"view-application-attendance-flex-time-excess-duty-approval-flex-time-excess-duty-approval-module","view-application-company-company-detail-company-detail-module":"view-application-company-company-detail-company-detail-module","view-application-company-company-profile-company-profile-module":"view-application-company-company-profile-company-profile-module","view-application-company-company-search-company-search-module":"view-application-company-company-search-company-search-module","view-application-employee-add-employee-add-employee-module":"view-application-employee-add-employee-add-employee-module","view-application-employee-my-profile-my-profile-module":"view-application-employee-my-profile-my-profile-module","view-application-employee-view-employee-search-view-employee-search-module":"view-application-employee-view-employee-search-view-employee-search-module","view-application-leave-employee-leave-balance-employee-leave-balance-module":"view-application-leave-employee-leave-balance-employee-leave-balance-module","view-application-leave-leave-adjustment-approval-detail-leave-adjustment-approval-detail-module":"view-application-leave-leave-adjustment-approval-detail-leave-adjustment-approval-detail-module","view-application-leave-leave-adjustment-approval-leave-adjustment-approval-module":"view-application-leave-leave-adjustment-approval-leave-adjustment-approval-module","view-application-leave-leave-adjustment-request-detail-leave-adjustment-request-detail-module":"view-application-leave-leave-adjustment-request-detail-leave-adjustment-request-detail-module","view-application-leave-leave-adjustment-request-leave-adjustment-request-module":"view-application-leave-leave-adjustment-request-leave-adjustment-request-module","view-application-leave-leave-adjustment-request-team-detail-leave-adjustment-request-team-detail-module":"view-application-leave-leave-adjustment-request-team-detail-leave-adjustment-request-team-detail-module","view-application-leave-leave-adjustment-request-team-leave-adjustment-request-team-module":"view-application-leave-leave-adjustment-request-team-leave-adjustment-request-team-module","view-application-leave-leave-eligibility-for-emp-leave-eligibility-for-emp-module":"view-application-leave-leave-eligibility-for-emp-leave-eligibility-for-emp-module","view-application-leave-leave-policy-config-leave-policy-config-module":"view-application-leave-leave-policy-config-leave-policy-config-module","view-application-leave-leave-request-approval-detail-leave-request-approval-detail-module":"view-application-leave-leave-request-approval-detail-leave-request-approval-detail-module","view-application-leave-leave-request-approval-leave-request-approval-module":"view-application-leave-leave-request-approval-leave-request-approval-module","view-application-leave-leave-request-detail-leave-request-detail-module":"view-application-leave-leave-request-detail-leave-request-detail-module","view-application-leave-leave-request-leave-request-module":"view-application-leave-leave-request-leave-request-module","view-application-leave-leave-request-team-detail-leave-request-team-detail-module":"view-application-leave-leave-request-team-detail-leave-request-team-detail-module","view-application-leave-leave-request-team-leave-request-team-module":"view-application-leave-leave-request-team-leave-request-team-module","view-application-salary-benefits-and-deductions-approval-benefits-and-deductions-approval-module":"view-application-salary-benefits-and-deductions-approval-benefits-and-deductions-approval-module","view-application-salary-benefits-and-deductions-approval-detail-benefits-and-deductions-approval-detail-module":"view-application-salary-benefits-and-deductions-approval-detail-benefits-and-deductions-approval-detail-module","view-application-salary-benefits-and-deductions-benefits-and-deductions-module":"view-application-salary-benefits-and-deductions-benefits-and-deductions-module","view-application-salary-sal-config-sal-config-module":"view-application-salary-sal-config-sal-config-module","view-application-salary-salary-configruation-approval-salary-configruation-approval-module":"view-application-salary-salary-configruation-approval-salary-configruation-approval-module","view-application-salary-salary-configuration-list-salary-configuration-list-module":"view-application-salary-salary-configuration-list-salary-configuration-list-module","view-application-salary-severance-pay-configuration-severance-pay-configuration-module":"view-application-salary-severance-pay-configuration-severance-pay-configuration-module","view-master-attendance-approval-hierarchy-config-approval-hierarchy-config-module":"view-master-attendance-approval-hierarchy-config-approval-hierarchy-config-module","view-master-attendance-attendace-time-type-attendace-time-type-module":"view-master-attendance-attendace-time-type-attendace-time-type-module","view-master-common-department-team-department-team-module":"view-master-common-department-team-department-team-module","view-master-common-training-type-training-training-type-training-module":"view-master-common-training-type-training-training-type-training-module","view-master-employee-benefits-deductions-benefits-deductions-module":"view-master-employee-benefits-deductions-benefits-deductions-module","view-master-employee-job-details-job-details-module":"view-master-employee-job-details-job-details-module","view-master-employee-others-others-module":"view-master-employee-others-others-module","view-master-holidays-holidays-module":"view-master-holidays-holidays-module","view-master-leave-mleave-type-module":"view-master-leave-mleave-type-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
